import { collection, getDocs, query, where } from "firebase/firestore";
import { useEffect, useMemo, useState } from "react";
import { firestore } from "../firebase";
import { mapSnapshotToUserProfile } from "../lib/map-snapshot-to-user-profile";
import { UserProfile } from "../types/User";

export function usePublicUserProfile(username: string | null | undefined) {
  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!username) {
      setProfile(null);
      setLoading(false);
      setError(null);
      return;
    }

    const findProfile = async () => {
      setLoading(true);
      setError(null);

      // Search for the user by username
      const profilesCollection = collection(firestore, "profiles");
      const q = query(profilesCollection, where("username", "==", username));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        setProfile(null);
        setError("User profile not found.");
        setLoading(false);
        return;
      }

      const profileDoc = querySnapshot.docs[0];
      setProfile(mapSnapshotToUserProfile(profileDoc.id, profileDoc.data()));
      setLoading(false);
    };

    findProfile();
  }, [username]);

  return useMemo(
    () => ({
      profile,
      loading: loading && !!username,
      error,
    }),
    [profile, loading, error, username]
  );
}
